import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateRankForm from '../CreateRankForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function CreateRankListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`สร้างกิจกรรม Rank`} description="สร้างกิจกรรม Rank" />
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateRankForm />
		</div>
	)
}
